module.exports = __webpack_public_path__ + "static/media/customerHome.20be8391.svg";